export class PbhRequestOrderFileRelationModel {
  public PbhRequestOrderId?: number;
  public FileId?: number;
  public PbhRequestFileTypeGroupEnum?: number;
  public PbhRequestFileTypeEnum?: number;
  public File: any;
}
